import axios from "api/axios";

// App Backend
export const getNotesBySessionId = async (sessionId) => {
    const response = await axios.get(`/api/notes/session/${sessionId}`);
    return response.data;
};

export const getNotesByUserID = async (userId, fromDate = null, toDate = null) => {
    const params = new URLSearchParams(); 
    if (fromDate) params.append('from', fromDate); 
    if (toDate) params.append('to',toDate); 
    const queryString = params.toString(); 
    const url = `/api/notes/user/${userId}${queryString ? `?${queryString}` : ''}`;
    const response = await axios.get(url);
    return response.data;
};

